import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const submitRepairOrder = create(actions.SUBMIT_REPAIR_ORDER);
